import { canSendDataToThirdParty, getNonPaginatedEndpoint } from '../utils.ts';
import { axiosInstanceV2 } from '../axios.ts';
import { ICEPResponse, ICNPJResponse } from './types.ts';

export async function getCEP(cep: string): Promise<ICEPResponse | undefined> {
  return canSendDataToThirdParty<Promise<ICEPResponse>>(cep, 8, () =>
    fetch('https://viacep.com.br/ws/' + cep + '/json/', {
      method: 'GET',
    }).then((request) => request.json().then((data) => data as ICEPResponse))
  );
}

export async function getCNPJ(cnpj: string): Promise<ICNPJResponse | undefined> {
  return canSendDataToThirdParty<Promise<ICNPJResponse>>(
    cnpj,
    14,
    (cleanedCNPJ) =>
      getNonPaginatedEndpoint(`/utils/cnpj/${cleanedCNPJ}/`, {}, axiosInstanceV2) as Promise<ICNPJResponse>
  );
}
